import React from 'react';
import Header from './Header';

export function Layout({ children }: React.PropsWithChildren<{}>) {
  return (
    <>
      <Header />
      { children }
    </>
  )
}